import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Flex, Heading, Text } from "rebass";
import { toastr } from "react-redux-toastr";

import { getUser } from "../../../store/modules/session/selectors";
import { getActiveInstance } from "../../../store/modules/library/selectors";
import { closeModal } from "../../../store/modules/modal/actions";

import { SubmitButton } from "../components/SubmitButton";
import { createDBPath, instanceSchema, errorList, updateInstance } from "../../../utils/Instance";

export const DeleteForm: React.FC = () => {
  const [isSubmitting, setSubmitting] = useState(false);
  const user = useSelector(getUser);
  const instance = useSelector(getActiveInstance);
  const dispatch = useDispatch();

  const handleCancel = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const handleDelete = useCallback(() => {
    setSubmitting(true);

    try {
      const validData = instanceSchema.validateSync({ user, instance });
      const DBPath = createDBPath(validData);
      const { instance: { type } } = validData;

      updateInstance[type](DBPath, { isArchived: true })
        .then(() => {
          setSubmitting(false);
          dispatch(closeModal());
        })
        .catch(({ message }: Error) => {
          setSubmitting(false);
          toastr.error(`Update ${type}`, message);
        });
    } catch ({ message }) {
      const error = errorList[message] || ["Update", message];

      toastr.error(...error);
      setSubmitting(false);
    }
  }, [user, instance, dispatch]);

  return instance && (
    (
      <Flex
        height="100%"
        flexDirection="column"
        css="min-height: 10rem; min-width: 30rem;"
      >
        <Heading
          as="h4"
          mt="17px"
          mx="17px"
        >
          Delete
        </Heading>

        <Text
          as="p"
          flex={1}
          m="17px"
        >
          <Text as="span">You are going to delete</Text>

          &nbsp;

          <Text
            as="b"
            px="2px"
            bg="sp-blue-25"
            css="display: inline-block; border-radius: 2px;"
          >
            {instance.type}
          </Text>

          &nbsp;

          <Text as="span">with name</Text>

          &nbsp;

          <Text
            as="b"
            px="2px"
            bg="sp-blue-25"
            css="display: inline-block; border-radius: 2px;"
          >
            {instance.title}
          </Text>
        </Text>

        <Card
          p="18px"
          fontSize="14px"
          bg="#fff"
          borderTop="2px solid"
          borderTopColor="sp-gray"
          css="display: flex; justify-content: space-between;"
        >
          <Button
            type="button"
            px="10px"
            py="5px"
            border="1px solid"
            borderColor="hoki"
            borderRadius="5px"
            color="hoki"
            bg="transparent"
            fontWeight="bold"
            css="text-transform: uppercase;"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            cancel
          </Button>

          <SubmitButton
            type="button"
            width="unset"
            px="10px"
            py="5px"
            onClick={handleDelete}
            disabled={isSubmitting}
          >
            delete
          </SubmitButton>
        </Card>
      </Flex>
    )
  );
};
